import React from "react"
import { Col } from "react-bootstrap"
import { useParams } from "react-router-dom"
import "../main.css"
import SearchResultDisp from "./SearchResultDisp"
import HeaderComponent from "../commonComponents/HeaderComponent"

function SearchFromHeader(props) {
   const params = useParams()
   const searchVal = params.searchText
   const searchType = params.searchType

   return (
      <React.Fragment>
         <HeaderComponent value={searchVal} type={searchType} />
         <Col className="searchTable">
            <SearchResultDisp
               searchData={searchVal}
               searchType={searchType}
            />
         </Col>
      </React.Fragment>
   )
}
export default SearchFromHeader